import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

export interface CheckboxProps {
    field?: any;
    form?: any;
    text: string;
    givenid: string;
    onChange?: (e) => void;
}

export default class BaseCheckbox extends Component<CheckboxProps, {}> {
    handleOnChange = () => {
        this.props.form.setFieldValue(
            this.props.field.name,
            !this.props.field.value
        );
    };

    render() {
        return (
            <div id={this.props.givenid + "Checkbox"}>
                <Components.Checkbox
                    onChange={this.handleOnChange}
                    checked={this.props.field.value}
                >
                    {this.props.text}
                </Components.Checkbox>
            </div>
        );
    }
}
